import React from 'react';
import { FaTiktok, FaYoutube, FaInstagram } from 'react-icons/fa';
import logo from './../../shortscreatorlogo.png';
import './landing-v2.css';

// v2 landing footer for Shorts Creator (standalone brand — no Ssemble references).
// Includes a real contact method + legal links, which reviewers look for on a
// "fully developed" website.
const FooterV2 = () => {
    return (
        <footer className="lp2-footer">
            <div className="lp2-foot-inner">
                <div className="lp2-foot-col">
                    <div className="lp2-foot-brand">
                        <img src={logo} alt="Shorts Creator" />
                        Shorts Creator
                    </div>
                    <p>
                        Turn long videos into viral shorts with AI, and publish them to TikTok,
                        YouTube, and Instagram — all in one place.
                    </p>
                    <div className="lp2-hero-platforms" style={{ marginTop: '18px', color: '#c3cfe4' }}>
                        <FaTiktok /> <FaYoutube /> <FaInstagram />
                    </div>
                </div>
                <div className="lp2-foot-col">
                    <div className="lp2-foot-links">
                        <a href="/">Home</a>
                        <a href="/upload">Connect Accounts</a>
                        <a href="/privacy">Privacy Policy</a>
                        <a href="/terms">Terms of Use</a>
                        <a href="mailto:minimalee3950@gmail.com">Contact</a>
                    </div>
                    <p style={{ marginTop: '18px' }}>
                        Questions? Email us at{' '}
                        <a href="mailto:minimalee3950@gmail.com" style={{ color: '#c3cfe4' }}>minimalee3950@gmail.com</a>
                    </p>
                </div>
            </div>
            <div className="lp2-foot-bottom">
                Copyright © 2026 Shorts Creator. All rights reserved.
            </div>
        </footer>
    );
};

export default FooterV2;
